import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';
import { GridSearchIcon } from '@mui/x-data-grid';
import DateTimeIntervalFilter from '../common/DateTimeRangeFilter';
import VideoRequestDialog from './VideoRequestDialog';

interface CCTVSearchFormProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  onSearch: () => void;
  onVideoRequestSuccess?: () => void;
}

export default function CCTVSearchForm({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onSearch,
  onVideoRequestSuccess,
}: CCTVSearchFormProps) {
  const { t } = useTranslation();
  const [showVideoRequestDialog, setShowVideoRequestDialog] = useState(false)

  return (
    <div>
      <Typography variant="h4" sx={{ mb: 3 }}>
        {t('cctv_search')}
      </Typography>
      <Box sx={{ mb: 2, gap: 2 }}>
        <DateTimeIntervalFilter
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
          startDate={startDate}
          endDate={endDate}
        />
      </Box>
      <Box sx={{ mb: 5, gap: 2 }}>
        <Button
          variant="contained"
          onClick={onSearch}
          sx={{ textTransform: 'none', mr: 2 }}
          startIcon={<GridSearchIcon />}
        >
          {t('search_videos')}
        </Button>
        <Button
          variant="contained"
          onClick={() => setShowVideoRequestDialog(true)}
          sx={{ textTransform: 'none', mr: 2}}
          startIcon={<SendIcon />}
        >
          {t('send_video_request')}
        </Button>
      </Box>
      <VideoRequestDialog 
        open={showVideoRequestDialog}
        onClose={() => setShowVideoRequestDialog(false)}
        onRequestSuccess={onVideoRequestSuccess}
      />
    </div>
  );
}
